export default class AnalyzeConfig {
  constructor({
    id,
    fieldName = '',
    fieldType = '',
    alias = '',
    openStatistics = false,
    analysisConfigDtoList = [],
    logId = null
  }) {
    this.id = id;
    this.fieldName = fieldName;
    this.fieldType = fieldType;
    this.alias = alias;
    this.openStatistics = openStatistics;
    this.analysisConfigDtoList = analysisConfigDtoList;
    this.logId = logId;
  }
}
